import P from "prop-types";
import * as S from "../styles";

import { BarChartCard } from "../../ChartCards/BarChartCard";
import { HorizontalBarChartCard } from "../../ChartCards/HorizontalBarChartCard";
import { SimplePieChartCard } from "../../ChartCards/SimplePieChartCard";
import { HorizontalZoomBarChartCard } from "../../ChartCards/HorizontalZoomBarChartCard";

import { dadosGraficos } from "../../dados";

export function Capitulo3({ currentIndex }) {
  const chartStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  if (currentIndex !== 3) {
    return <></>;
  } else {
    return (
      <S.Container>
        <S.Container2>
          <BarChartCard
            title="Tempo de formação"
            dados={dadosGraficos.grafico23}
            style={chartStyle}
          />
          <S.Grid>
            <HorizontalBarChartCard
              grid
              title="Jornada semanal de trabalho"
              dados={dadosGraficos.grafico26}
              style={chartStyle}
            />

            <SimplePieChartCard
              grid
              title="Considera que o treinamento foi satisfatório"
              dados={dadosGraficos.grafico30}
              style={chartStyle}
            />
          </S.Grid>

          <HorizontalBarChartCard
            title="Instituição de trabalho."
            dados={dadosGraficos.grafico24}
            style={chartStyle}
          />

          <S.Grid>
            <SimplePieChartCard
              grid
              title="Já trabalhou com doenças infecciosas"
              dados={dadosGraficos.grafico27}
              style={chartStyle}
            />
            <SimplePieChartCard
              grid
              title="Foi treinado para atuar no combate à covid-19"
              dados={dadosGraficos.grafico29}
              style={chartStyle}
            />
          </S.Grid>

          <HorizontalZoomBarChartCard
            title="Tipo de vínculo empregatício"
            dados={dadosGraficos.grafico25}
            style={chartStyle}
          />
        </S.Container2>
      </S.Container>
    );
  }
}

Capitulo3.propTypes = {
  currentIndex: P.number,
};
